import { useState } from "react";
import { Button } from "semantic-ui-react";

import { PlanITModal } from "components/PlanIT/components";
import "components/PlanIT/PlanIT.scss";

type PlanITProps = {
  appointment_id: number;
  hasPlanITData: boolean;
};

export const PlanIT = ({ appointment_id, hasPlanITData }: PlanITProps) => {
  const [showModal, setShowModal] = useState(false);

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  return (
    <>
      <div className="PlanITButton-container">
        <Button size="small" className={`-appointment-status ${hasPlanITData ? "planITData" : ""}`} onClick={openModal}>
          Plan-IT
        </Button>
      </div>

      {showModal && <PlanITModal closeModal={closeModal} appointmentId={appointment_id} />}
    </>
  );
};
